module.exports = __webpack_public_path__ + "img/price-network.00ad53f8.png";